// extracted by mini-css-extract-plugin
module.exports = {"Rounds":"Rounds_Rounds__3OPiU"};